<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     增值-优惠券方案详情
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="ei-coupon-detail padding-footer">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>
    <el-card shadow="never">
      <div class="front-line mb-lg">基本信息</div>
      <el-form v-loading="loading" class="display-form" label-position="left" label-width="120px">
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="券类型">
              <span class="mr-sm">{{ coupon.coupon_type == 1 ? '满减券' : coupon.coupon_type == 2 ? '折扣券' : '新用户券' }}</span>
              {{ coupon.name }}
            </el-form-item>
            <el-form-item label="券有效期">
              {{ '领取后' + coupon.valid_days + '天内有效' }}
            </el-form-item>
            <el-form-item label="使用范围">
              {{ coupon.use_range }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              {{ coupon.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}
            </el-form-item>
            <el-form-item label="状态">
              <div v-if="coupon.receive_status != 3" class="flex align-items-center">
              <div class="mr-sm" :class="coupon.receive_status == 1 ? 'text-warning' : 'text-primary'">{{ coupon.receive_status == 1 ? '未生效' : '已生效' }}</div>
              <el-switch v-model="coupon.receive_enable" :active-value="2" :inactive-value="1" @change="enableChange()" />
            </div>
            <div v-else class="text-muted">已失效</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
     <el-card shadow="never" class="mt-md">
      <div class="front-line mb-lg">数据统计</div>
      <div class="flex mb-md">
        <div class="flex column total-item">
          <div class="">累计使用张数</div>
          <div class="mt-md"><span class="font-2x mr-xs">{{ coupon.used_num }}</span><span>张</span></div>
        </div>

        <div class="flex column total-item border-left">
          <div class="">累计领取张数</div>
          <div class="mt-md"><span class="font-2x mr-xs">{{ coupon.receive_num }}</span><span>张</span></div>
        </div>
      </div>
      <div class="filter-container">
        <div class="filter-box">
          <div class="filter-item reverse">
            <el-select v-model="query.coupon_status" placeholder="使用状态" filterable clearable style="width: 160px;" @change="fetchList(1)">
              <el-option
                v-for="item in type"
                :key="item.value"
                :label="item.title"
                :value="item.value" />
            </el-select>
          </div>
          <div class="filter-item reverse">
            <f-member-selector v-model="query.receive_memberid" @change="fetchList(1)" />
          </div>
        </div>
      </div>

      <el-table v-loading="listLoading" ref="listTable" :data="list" tooltip-effect="dark" class="padding-small">
        <el-table-column label="#" type="index" width="50" />
         <el-table-column width="50" align="right">
          <template slot-scope="scope">
            <f-user-avatar :src="scope.row.avatar" shape="rounded" />
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="昵称" min-width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.nickname }}</span>
          </template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" label="使用状态" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.coupon_status == 1" class="text-danger">{{ '未使用' }}</span>
            <span v-if="scope.row.coupon_status == 2" class="text-primary">{{ '已使用' }}</span>
            <span v-if="scope.row.coupon_status == 3" class="text-muted">{{ '已过期' }}</span>
            <span v-if="scope.row.coupon_status == 4" class="text-muted">{{ '已失效' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="领取时间" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.receive_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>

        <el-table-column label="过期时间" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.expire_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>

        <el-table-column label="使用时间" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.use_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>

        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt="" class="no-data">
          </div>
        </div>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { couponEnableApi, couponGetApi, couponeiReceiveListApi } from "@/api/ei/eiCouponApi"

export default {
  name: "EiCouponDetail",

  components: {
  },

  data() {
    return {
      loading: false,
      listLoading: false,
      coupon: {},
      query: {
        coupon_schemeid: this.$route.query.coupon_schemeid,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        receive_memberid: null,
        coupon_status: null,
      },
      list: [],
      total: 0,
      type: [
        { value: 1, title: '未使用'},
        { value: 2, title: '已使用' },
        { value: 3, title: '已过期' },
        { value: 4, title: '已失效' },
      ],
    }
  },

  computed: {
    superFastLogin() {
      return this.$store.state.userStore.superFastLogin;
    },
    
    aiot_version() {
      return this.$store.state.godStore.aiot_version;
    },
  },

  created() {
    this.fetchData()
    this.fetchList(1)
  },

  methods: {
    fetchData() {
      this.loading = true
      couponGetApi({ coupon_schemeid: this.query.coupon_schemeid }).then((res) => {
        this.loading = false
        if (!res.errno) {
          this.coupon = Object.assign({}, res.data)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    fetchList(page) {
      if (page) this.query.pindex = page
      this.listLoading = true
      couponeiReceiveListApi(this.query).then((res) => {
        this.listLoading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },

    enableChange() {
      if (!this.superFastLogin && this.aiot_version == 2) {
        this.coupon.receive_enable = this.coupon.receive_enable == 2 ? 1 : 2
        this.$alert('合作版暂不支持该操作！', '提示', {
          type: 'warning'
        })
        return
      }
      this.$confirm(this.coupon.receive_enable == 2 ? `此操作将开启 <span class="text-primary">${this.coupon.name}</span> 优惠券方案，是否继续？` : `此操作将关闭 <span class="text-primary">${this.coupon.name}</span> 优惠券方案，但已领取的优惠券仍能使用，是否继续？`, '提示', {
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        couponEnableApi({ coupon_schemeid: this.coupon.coupon_schemeid, receive_enable: this.coupon.receive_enable }).then(res => {
          if (!res.errno) {
            this.fetchData()
            this.$message.success('操作成功')
          } else {
            this.coupon.receive_enable = this.coupon.receive_enable == 2 ? 1 : 2
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
        this.coupon.receive_enable = this.coupon.receive_enable == 2 ? 1 : 2
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.ei-coupon-detail {
  .total-item {
    padding: 0px 40px;
  }
  .border-left {
    border-left: 2px solid #ccc;
  }
}
</style>